export default `/**
 * Ids Button Group Section CSS
 * (Includes standard and icon button rules)
 */
/* stylelint-disable-next-line property-no-deprecated */
/**
 * Provides standardized padding rules for certain button types
 */
/**
 * Provides the standard color rules for all regular buttons
 */
/**
 * Provides the standard color rules for buttons that need box shadow
 */
/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host([hide]) {
  display: none;
}

@container (width >= 320px) {
  :host([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([hide=xxl]) {
    display: block;
  }
}
@media (width >= 320px) {
  :host([hide=xs]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 767px) {
  :host([hide=sm]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 927px) {
  :host([hide=md]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 928px) {
  :host([hide=lg]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host([hide=xl]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host([hide=xxl]:not(.in-container)) {
    display: block;
  }
}
:host([hide=always]) {
  display: none;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  flex-grow: 1;
  min-block-size: 0;
  overflow: hidden;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([hidden]) {
  display: none;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([align-items=center-inputs]),
.ids-layout-flex-align-items-center-inputs {
  align-items: start;
}

:host([align-items=center-inputs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}
:host([align-items=center-inputs]) ::slotted(ids-layout-flex-item.has-checkbox) {
  align-self: end;
}

:host([align-items=center-inputs][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([align-items=center-inputs][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([align-items=center-inputs][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([gap=none]),
.ids-layout-flex-gap-none {
  gap: 0;
}

:host([gap-x=none]),
.ids-layout-flex-gap-x-none {
  row-gap: 0;
}

:host([gap-y=none]),
.ids-layout-flex-gap-y-none {
  column-gap: 0;
}

:host([gap=xs]),
.ids-layout-flex-gap-xs {
  gap: 8px;
}

:host([gap-x=xs]),
.ids-layout-flex-gap-x-xs {
  row-gap: 8px;
}

:host([gap-y=xs]),
.ids-layout-flex-gap-y-xs {
  column-gap: 8px;
}

:host([gap=sm]),
.ids-layout-flex-gap-sm {
  gap: 16px;
}

:host([gap-x=sm]),
.ids-layout-flex-gap-x-sm {
  row-gap: 16px;
}

:host([gap-y=sm]),
.ids-layout-flex-gap-y-sm {
  column-gap: 16px;
}

:host([gap=md]),
.ids-layout-flex-gap-md {
  gap: 24px;
}

:host([gap-x=md]),
.ids-layout-flex-gap-x-md {
  row-gap: 24px;
}

:host([gap-y=md]),
.ids-layout-flex-gap-y-md {
  column-gap: 24px;
}

:host([gap=lg]),
.ids-layout-flex-gap-lg {
  gap: 32px;
}

:host([gap-x=lg]),
.ids-layout-flex-gap-x-lg {
  row-gap: 32px;
}

:host([gap-y=lg]),
.ids-layout-flex-gap-y-lg {
  column-gap: 32px;
}

:host([gap=xl]),
.ids-layout-flex-gap-xl {
  gap: 40px;
}

:host([gap-x=xl]),
.ids-layout-flex-gap-x-xl {
  row-gap: 40px;
}

:host([gap-y=xl]),
.ids-layout-flex-gap-y-xl {
  column-gap: 40px;
}

:host([padding=xxs]),
.ids-layout-flex-padding-xxs {
  padding: 4px;
}

:host([padding-x=xxs]),
.ids-layout-flex-padding-x-xxs {
  padding-inline: 4px;
}

:host([padding-y=xxs]),
.ids-layout-flex-padding-y-xxs {
  padding-block: 4px;
}

:host([padding=xs]),
.ids-layout-flex-padding-xs {
  padding: 8px;
}

:host([padding-x=xs]),
.ids-layout-flex-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-y=xs]),
.ids-layout-flex-padding-y-xs {
  padding-block: 8px;
}

:host([padding=sm]),
.ids-layout-flex-padding-sm {
  padding: 16px;
}

:host([padding-x=sm]),
.ids-layout-flex-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-y=sm]),
.ids-layout-flex-padding-y-sm {
  padding-block: 16px;
}

:host([padding=md]),
.ids-layout-flex-padding-md {
  padding: 24px;
}

:host([padding-x=md]),
.ids-layout-flex-padding-x-md {
  padding-inline: 24px;
}

:host([padding-y=md]),
.ids-layout-flex-padding-y-md {
  padding-block: 24px;
}

:host([padding=lg]),
.ids-layout-flex-padding-lg {
  padding: 32px;
}

:host([padding-x=lg]),
.ids-layout-flex-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-y=lg]),
.ids-layout-flex-padding-y-lg {
  padding-block: 32px;
}

:host([padding=xl]),
.ids-layout-flex-padding-xl {
  padding: 40px;
}

:host([padding-x=xl]),
.ids-layout-flex-padding-x-xl {
  padding-inline: 40px;
}

:host([padding-y=xl]),
.ids-layout-flex-padding-y-xl {
  padding-block: 40px;
}

:host([margin=xs]),
.ids-layout-flex-margin-xs {
  margin: 16px;
}

:host([margin-y=xs]),
.ids-layout-flex-margin-y-xs {
  margin-block: 16px;
}

:host([margin=sm]),
.ids-layout-flex-margin-sm {
  margin: 16px;
}

:host([margin-y=sm]),
.ids-layout-flex-margin-y-sm {
  margin-block: 16px;
}

:host([margin=md]),
.ids-layout-flex-margin-md {
  margin: 16px;
}

:host([margin-y=md]),
.ids-layout-flex-margin-y-md {
  margin-block: 16px;
}

:host([margin=lg]),
.ids-layout-flex-margin-lg {
  margin: 24px;
}

:host([margin-y=lg]),
.ids-layout-flex-margin-y-lg {
  margin-block: 24px;
}

:host([margin=xl]),
.ids-layout-flex-margin-xl {
  margin: 24px;
}

:host([margin-y=xl]),
.ids-layout-flex-margin-y-xl {
  margin-block: 24px;
}

:host([margin=auto]),
.ids-layout-flex-margin-auto {
  margin: auto;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
}

::slotted(ids-button) {
  flex: 1;
}

::slotted(ids-modal-button) {
  flex: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
